const AllMerchants = () => {
	return <div>AllMerchants</div>;
};

export default AllMerchants;
